import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

export type CenteringWrapperProps = {
  top?: number;
  left?: number;
  bottom?: number;
  right?: number;
} & HTMLAttributes<HTMLDivElement>;

const CenteringWrapper: ComponentType<CenteringWrapperProps> = styled('div')(({ top, left, bottom, right }: CenteringWrapperProps) => ({
  position: 'fixed',
  top: `${top || 0}px`,
  left: `${left || 0}px`,
  bottom: `${bottom || 0}px`,
  right: `${right || 0}px`,
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  alignItems: 'center',
}));

export default CenteringWrapper;